import {
  get as getCookie,
  remove as removeCookie,
  set as setCookie,
} from "../js/utils/cookie/cookie";

export default class ContactTestamentForm {
  /**
   * Initialize ContactTestamentForm instance.
   *
   * @param {string} formSelector - CSS selector for the form.
   * @param {string} startEvent - Name of the cookie for the start event.
   * @param {string} submitEvent - Name of the cookie for the submit event.
   */
  constructor(formSelector, startEvent, submitEvent) {
    this.startEvent = startEvent;
    this.submitEvent = submitEvent;

    this.ContactTestamentForm = document.querySelector(formSelector);

    this.ContactTestamentFormTitle =
      this.ContactTestamentForm?.getAttribute("data-form-title");
    this.ContactTestamentFormId =
      this.ContactTestamentForm?.getAttribute("data-form-id");

    if (this.ContactTestamentForm) {
      this._init();
    }

    this._bindCookies();
  }

  /**
   * Bind initial events to the form.
   *
   * @private
   */
  _init() {
    this.ContactTestamentForm.addEventListener(
      "input",
      () =>
        ContactTestamentForm._onFirstInput(
          this.startEvent,
          this.ContactTestamentFormTitle,
          this.ContactTestamentFormId
        ),
      { once: true }
    );
  }

  /**
   * Bind cookies for form submission tracking.
   *
   * @private
   */
  _bindCookies() {
    const submit = getCookie(this.submitEvent);

    if (submit) {
      ContactTestamentForm._onFormSubmit(this.submitEvent, JSON.parse(submit));
    }
  }

  /**
   * Handle the first input event. Set a cookie and push event to dataLayer.
   *
   * @param {string} startEvent - Name of the cookie for the start event.
   * @param {string} formTitle - Title of the form
   * @param {string} formId - Id of the form element
   * @private
   * @static
   */
  static _onFirstInput(startEvent, formTitle, formId) {
    if (!getCookie(startEvent)) {
      window.dataLayer.push({
        event: "Event",
        event_name: "form_started",
        form_started: {
          form_goal: "Contact",
          form_plugin: "Drupal",
          form_title: formTitle,
          form_id: formId,
        },
      });
    }

    setCookie(startEvent, 1, {
      path: "/",
      end: 60 * 15,
      SameSite: "Lax",
      secure: true,
    });
  }

  /**
   * Handle form submission event. Remove the submission cookie and push event to dataLayer.
   *
   * @param {string} submitEvent - Name of the cookie for the submit event.
   * @param {object} data - Content of submit cookie
   * @private
   * @static
   */
  static _onFormSubmit(submitEvent, data) {
    window.dataLayer.push({
      event: "Event",
      event_name: "form_submitted",
      form_submitted: {
        form_goal: "Contact",
        form_plugin: "Drupal",
        form_title: data.form_title,
        form_id: data.form_id,
        form_contains_newsletter_subscription:
          data.form_contains_newsletter_subscription || false,
        form_contains_address_field: data.form_contains_address_field || false,
        form_contains_phone_field: data.form_contains_phone_field || false,
        phone_field_provided: data.phone_field_provided || false,
        newsletter_subscribed: data.newsletter_subscribed || false,
      },
    });
    removeCookie(submitEvent, { path: "/" });
  }
}
